const formatDistance = (distance, isPreview) => {
  if (!isPreview) {
    return distance + 'px';
  }
  return distance / 7 + '%';
};

const GetAlignStyles = (setting, isPreview = false) => {
  const styles = {
    position: isPreview ? 'absolute' : 'fixed',
    zIndex: 9999
  };
  if (!setting.status && !isPreview) {
    styles.display = 'none';
  }
  if (setting.position === 'bl') {
    styles.bottom = formatDistance(setting.verticalMargin, isPreview);
    styles.left = formatDistance(setting.horizontalMargin, isPreview);
  } else if(setting.position === 'br') {
    styles.bottom = formatDistance(setting.verticalMargin, isPreview);
    styles.right = formatDistance(setting.horizontalMargin, isPreview);
  } else if(setting.position === 'tl') {
    styles.top = formatDistance(setting.verticalMargin, isPreview);
    styles.left = formatDistance(setting.horizontalMargin, isPreview);
  } else if(setting.position === 'tr') {
    styles.top = formatDistance(setting.verticalMargin, isPreview);
    styles.right = formatDistance(setting.horizontalMargin, isPreview);
  }
  return styles;
}

export default GetAlignStyles;